import { FiSearch, FiBell, FiMail } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";

function getPageMeta(pathname) {
  const clean = pathname.replace(/\/+$/, "") || "/";

  const routes = [
    { path: "/", title: "Dashboard", subtitle: "Dashboard / Overview" },
    { path: "/containers", title: "Containers", subtitle: "Dashboard / Containers" },
    { path: "/invoices", title: "Invoices", subtitle: "Dashboard / Invoices" },
    { path: "/invoices/create", title: "Create Invoice", subtitle: "Dashboard / Invoices / Create" },
    { path: "/cost-price-list", title: "Cost Price List", subtitle: "Dashboard / Cost Price List" },
    { path: "/vendors", title: "Vendors", subtitle: "Dashboard / Vendors" },
    { path: "/payments", title: "Payments", subtitle: "Dashboard / Payments" },
    { path: "/reports", title: "Reports", subtitle: "Dashboard / Reports" },
    { path: "/settings", title: "Settings", subtitle: "Dashboard / Settings" },
    { path: "/help", title: "Help", subtitle: "Dashboard / Help" },
    { path: "/profile", title: "Profile", subtitle: "Dashboard / Profile" },
  ];

  if (clean.startsWith("/invoices/") && clean.endsWith("/print")) {
    return { title: "Invoice Print", subtitle: "Dashboard / Invoices / Print" };
  }

  const match = routes.find((route) => route.path === clean);
  return match || { title: "Page", subtitle: "Dashboard" };
}

export default function Topbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch {
        setUser(null);
      }
    }
  }, []);

  const pageMeta = useMemo(() => getPageMeta(location.pathname), [location.pathname]);

  return (
    <header className="flex h-20 items-center justify-between border-b border-slate-200 bg-white px-6 shadow-sm transition-colors duration-300 dark:border-slate-800 dark:bg-slate-900">
      <div>
        <h1 className="text-[34px] font-semibold leading-none text-slate-800 dark:text-slate-100">
          {pageMeta.title}
        </h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          {pageMeta.subtitle}
        </p>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex h-11 w-72 items-center gap-3 rounded-full border border-slate-200 bg-white px-4 shadow-sm transition-colors duration-300 dark:border-slate-700 dark:bg-slate-950">
          <FiSearch className="text-slate-400" />
          <input
            type="text"
            placeholder="Search..."
            className="w-full bg-transparent text-sm outline-none placeholder:text-slate-400 dark:text-slate-100"
          />
        </div>

        <button className="relative grid h-11 w-11 place-items-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition-colors duration-300 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300">
          <FiBell className="text-lg" />
          <span className="absolute -right-0 -top-1 rounded-full bg-red-500 px-1.5 text-[10px] font-bold text-white">
            2
          </span>
        </button>

        <button className="grid h-11 w-11 place-items-center rounded-full border border-slate-200 bg-white text-slate-600 shadow-sm transition-colors duration-300 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-300">
          <FiMail className="text-lg" />
        </button>

        <button
          type="button"
          onClick={() => navigate("/profile")}
          className="h-11 w-11 overflow-hidden rounded-full border border-slate-200 shadow-sm dark:border-slate-700"
          aria-label="Open profile"
        >
          <img
            src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
              user?.name || "User"
            )}&background=0D8ABC&color=fff&size=128`}
            alt="Profile"
            className="h-full w-full object-cover"
          />
        </button>
      </div>
    </header>
  );
}